export const checkHasUsedCouponsWithBook = (coupons, bookId) => {
  const targetCoupons = coupons.filter((coupon) => coupon.book_id == bookId);
  return targetCoupons.some((coupon) => isUsedCoupon(coupon));
};

const isUsedCoupon = (coupon) => {
  return coupon.used_count > 0;
};
